import { createUrl, moduleConfigCreator, reportsConfig } from '@infotech/4sides-reports'
import { AsyncComponent } from '@infotech/base-components'
import { REPORTS_CORE_URL } from 'api/constants'

export default moduleConfigCreator({
  config: {
    ...reportsConfig,
    reportsUrl: createUrl(REPORTS_CORE_URL),
  },
  RouteComponent: AsyncComponent(() => import(`./RouteComponent`)),
})
